import{a as o}from"./chunk-QEKOZYJ5.js";import{a as r}from"./chunk-RAAYCPUM.js";function m(...n){return r(i,n)}function i(n,t,e){let a=e(t,void 0,n);return o(n,(d,u)=>e(d,u,n)<=a)}export{m as a};
